import React, { Component } from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Divider,
  Chip,
} from '@mui/material'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { Row, Col, Button, Spinner } from 'reactstrap'
import Infobox from '../Infos/Infobox'

const REPORTS_WITH_COMPARISON = ['busy', 'busyraw', 'busyvisual']

const TIME_PRESETS = [
  { label: 'Eilen', value: 'yesterday' },
  { label: 'Viime viikko', value: 'lastWeek' },
  { label: 'Tämä viikko', value: 'thisWeek' },
  { label: 'Viime kk', value: 'lastMonth' },
  { label: 'Tämä kuukausi', value: 'thisMonth' },
  { label: '2 kk', value: 'last2Months' },
  { label: '3 kk', value: 'last3Months' },
  { label: '30 pv', value: 'last30' },
  { label: '90 pv', value: 'last90' },
  { label: 'Tämä vuosi', value: 'thisYear' },
  { label: 'Viime vuosi', value: 'lastYear' },
]

const getPresetDates = (preset) => {
  const today = moment.utc()
  let start, end, compStart, compEnd
  switch (preset) {
    case 'yesterday':
      start = today.clone().subtract(1, 'day')
      end = today.clone().subtract(1, 'day')
      compStart = today.clone().subtract(8, 'days')
      compEnd = today.clone().subtract(8, 'days')
      break
    case 'lastWeek':
      start = today.clone().subtract(1, 'week').startOf('isoWeek')
      end = today.clone().subtract(1, 'week').endOf('isoWeek')
      compStart = start.clone().subtract(1, 'week')
      compEnd = end.clone().subtract(1, 'week')
      break
    case 'thisWeek':
      start = today.clone().startOf('isoWeek')
      end = today.clone()
      compStart = start.clone().subtract(1, 'week')
      compEnd = end.clone().subtract(1, 'week')
      break
    case 'lastMonth':
      start = today.clone().subtract(1, 'month').startOf('month')
      end = today.clone().subtract(1, 'month').endOf('month')
      compStart = start.clone().subtract(1, 'month')
      compEnd = end.clone().subtract(1, 'month')
      break
    case 'thisMonth':
      start = today.clone().startOf('month')
      end = today.clone()
      compStart = start.clone().subtract(1, 'month')
      compEnd = compStart.clone().add(end.diff(start, 'days'), 'days')
      break
    case 'last2Months':
      start = today.clone().subtract(2, 'months').startOf('month')
      end = today.clone().subtract(1, 'month').endOf('month')
      compStart = start.clone().subtract(2, 'months')
      compEnd = end.clone().subtract(2, 'months')
      break
    case 'last3Months':
      start = today.clone().subtract(3, 'months').startOf('month')
      end = today.clone().subtract(1, 'month').endOf('month')
      compStart = start.clone().subtract(3, 'months')
      compEnd = end.clone().subtract(3, 'months')
      break
    case 'last30':
      start = today.clone().subtract(30, 'days')
      end = today.clone()
      compStart = start.clone().subtract(31, 'days')
      compEnd = start.clone().subtract(1, 'day')
      break
    case 'last90':
      start = today.clone().subtract(90, 'days')
      end = today.clone()
      compStart = start.clone().subtract(91, 'days')
      compEnd = start.clone().subtract(1, 'day')
      break
    case 'thisYear':
      start = today.clone().startOf('year')
      end = today.clone()
      compStart = start.clone().subtract(1, 'year')
      compEnd = end.clone().subtract(1, 'year')
      break
    case 'lastYear':
      start = today.clone().subtract(1, 'year').startOf('year')
      end = today.clone().subtract(1, 'year').endOf('year')
      compStart = start.clone().subtract(1, 'year')
      compEnd = end.clone().subtract(1, 'year')
      break
    default:
      return null
  }
  return {
    startdate: start.format('YYYY-MM-DD'),
    enddate: end.format('YYYY-MM-DD'),
    comparisonstartdate: compStart.format('YYYY-MM-DD'),
    comparisonenddate: compEnd.format('YYYY-MM-DD'),
  }
}

const getTimeSteps = (step) => {
  const times = []
  let tt = 0 // start time
  for (var i = 0; tt < 24 * 60; i++) {
    var hh = Math.floor(tt / 60) // getting hours of day in 0-24 format
    var mm = tt % 60 // getting minutes of the hour in 0-55 format
    times[i] = ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2) // pushing data in array in [00:00 - 12:00 AM/PM format]
    tt = tt + step
  }
  times.push('23:59')
  return times
}

const getPrevDates = (start, end) => {
  const startdate = moment.utc(start)
  const enddate = moment.utc(end)
  let diff = enddate.diff(startdate, 'days')
  if (diff < 1) {
    diff = 1
  } else {
    diff = diff + 1
  }

  return [startdate.subtract(diff, 'days'), enddate.subtract(diff, 'days')]
}

class ReportsTimePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      report: this.props.report,
      loading: this.props.loading,
      venues: this.props.venues,
      selectedVenue: '',
      startdate: moment.utc().subtract(1, 'day').format('YYYY-MM-DD'),
      enddate: moment.utc().subtract(1, 'day').format('YYYY-MM-DD'),
      starttime: '06:00',
      endtime: '23:00',
      comparisonstartdate: moment
        .utc()
        .subtract(2, 'days')
        .format('YYYY-MM-DD'),
      comparisonenddate: moment.utc().subtract(2, 'days').format('YYYY-MM-DD'),
      comparisonstarttime: '06:00',
      comparisonendtime: '23:00',
      comparison: false,
      allvalid: true,
      selectedPreset: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.report !== this.props.report) {
      this.setState({ report: this.props.report })
    }
    if(prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading })
    }
  }

  getReport = () => {
    const report = {
      report: this.state.report,
      startdate: this.state.startdate,
      enddate: this.state.enddate,
      starttime: this.state.starttime,
      endtime: this.state.endtime,
      comparison: this.state.comparison,
      comparisonstartdate: this.state.comparisonstartdate,
      comparisonenddate: this.state.comparisonenddate,
      comparisonstarttime: this.state.comparisonstarttime,
      comparisonendtime: this.state.comparisonendtime,
      venue: this.state.selectedVenue,
    }
    this.props.onSubmit(report)
  }

  applyPreset = (preset) => {
    const dates = getPresetDates(preset)
    if (!dates) return
    this.setState({
      ...dates,
      comparison: true,
      allvalid: true,
      selectedPreset: preset,
    })
  }

  setStartDate = (e) => {
    this.setState({ startdate: e.target.value, selectedPreset: null })
  }

  setEndDate = (e) => {
    this.setState({ enddate: e.target.value, selectedPreset: null })
  }

  setStarttime = (e) => {
    this.setState({ starttime: e.target.value })
  }

  setEndtime = (e) => {
    this.setState({ endtime: e.target.value })
  }

  setVenue = (e) => {
    this.setState({ selectedVenue: e.target.value })
  }

  setComparisonStartDate = (e) => {
    const comparisonstartdate = e.target.value
    const allvalid = moment.utc(comparisonstartdate).isSameOrBefore(moment.utc(this.state.enddate))
    this.setState({ comparisonstartdate, allvalid })
  }

  setComparisonEndDate = (e) => {
    const comparisonenddate = e.target.value
    console.log(comparisonenddate, this.state.comparisonstartdate )
    const allvalid = moment.utc(moment.utc(this.state.comparisonstartdate)).isSameOrBefore(comparisonenddate) && moment.utc(comparisonenddate).isSameOrBefore(moment.utc(this.state.startdate))
    this.setState({ comparisonenddate, allvalid })
  }

  setComparisonStarttime = (e) => {
    const comparisonstarttime = e.target.value
    this.setState({ comparisonstarttime })
  }

  setComparisonEndtime = (e) => {
    const comparisonendtime = e.target.value
    this.setState({ comparisonendtime })
  }
  setComparison = (e) => {
    if (e.target.checked) {
      const [startdate, enddate] = getPrevDates(
        this.state.startdate,
        this.state.enddate
      )
      console.log(this.state.startdate, this.state.enddate)
      console.log(startdate.format('YYYY-MM-DD'), enddate.format('YYYY-MM-DD'))
      this.setState({
        comparison: e.target.checked,
        comparisonstartdate: startdate.format('YYYY-MM-DD'),
        comparisonenddate: enddate.format('YYYY-MM-DD'),
      })
    } else {
      this.setState({ comparison: e.target.checked })
    }
  }

  render() {
    return (
      <>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {this.state.report === 'busyvisual' && (
            <Row style={{ marginBottom: 8 }}>
              <Col>
                {TIME_PRESETS.map((p) => (
                  <Chip
                    key={p.value}
                    label={p.label}
                    onClick={() => this.applyPreset(p.value)}
                    variant={this.state.selectedPreset === p.value ? 'filled' : 'outlined'}
                    color={this.state.selectedPreset === p.value ? 'primary' : 'default'}
                    size='small'
                    style={{ marginRight: 6, marginBottom: 4 }}
                  />
                ))}
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={6} md={6}>
              {this.state.report !== 'persons' && (
                <TextField
                  id='recurstart'
                  label='Alkupäivä'
                  type='date'
                  variant='standard'
                  // defaultValue={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : ''}
                  value={
                    this.state.startdate
                      ? moment.utc(this.state.startdate).format('YYYY-MM-DD')
                      : moment.utc().subtract(1, 'day').format('YYYY-MM-DD')
                  }
                  onChange={this.setStartDate}
                  style={{ marginRight: 25 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              {/* </Col>
            <Col> */}
              {this.state.report !== 'persons' && (
                <TextField
                  id='recurstart'
                  label='Loppupäivä'
                  type='date'
                  variant='standard'
                  value={
                    this.state.enddate
                      ? moment.utc(this.state.enddate).format('YYYY-MM-DD')
                      : moment.utc().format('YYYY-MM-DD')
                  }
                  onChange={this.setEndDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ marginRight: 25 }}
                />
              )}
              {/* </Col> */}

              {this.state.venues && this.state.venues.length > 0 ? (
                <Col>
                  <FormControl style={{ width: '100%' }}>
                    <InputLabel id='venue'>Paikka</InputLabel>
                    <Select
                      fullWidth
                      labelId='venue-label'
                      id='venue'
                      value={this.state.selectedVenue || ''}
                      onChange={this.setVenue}
                    >
                      {this.state.venues.map((v, i) => {
                        return (
                          <MenuItem
                            key={v.name.toLowerCase()}
                            value={v.name.toLowerCase()}
                          >
                            {v.name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </Col>
              ) : null}
              {this.state.report === 'busy' ||
              this.state.report === 'busyraw' ||
              this.state.report === 'busyvisual' ? (
                <>
                  {/* <Col> */}
                  <FormControl>
                    <InputLabel id='starttime-select-label'>
                      Alkuaika
                    </InputLabel>
                    <Select
                      labelId='starttime-select-label'
                      id='starttime-select-label'
                      value={this.state.starttime || '07:00'}
                      onChange={this.setStarttime}
                    >
                      {getTimeSteps(15).map((v, i) => {
                        return (
                          <MenuItem key={v} value={v}>
                            {v}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>{' '}
                  <FormControl>
                    <InputLabel id='endttime-select-label'>
                      Loppuaika
                    </InputLabel>
                    <Select
                      labelId='endttime-select-label'
                      id='endttime-select-label'
                      value={this.state.endtime || '23:00'}
                      onChange={this.setEndtime}
                    >
                      {getTimeSteps(15).map((v, i) => {
                        return (
                          <MenuItem key={v} value={v}>
                            {v}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                  {/* </Col> */}
                </>
              ) : null}
            </Col>
          </Row>

          {REPORTS_WITH_COMPARISON.includes(this.state.report) ? (
            <div>
              {this.state.comparison && <Divider style={{ marginTop: 20 }} />}
              <Row>
                <Col xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.comparison}
                        onChange={this.setComparison}
                        name='comparison'
                        color='primary'
                      />
                    }
                    label='Vertaa aiempaan aikaväliin'
                  />
                </Col>
              </Row>
              {this.state.comparison && (
                <>
                  <Row>
                    <Col xs={6} md={6}>
                      {this.state.report !== 'persons' && (
                        <TextField
                          id='comparisonstart'
                          label='Alkupäivä'
                          type='date'
                          variant='standard'
                          value={
                            this.state.comparisonstartdate
                              ? moment
                                  .utc(this.state.comparisonstartdate)
                                  .format('YYYY-MM-DD')
                              : moment
                                  .utc()
                                  .subtract(1, 'day')
                                  .format('YYYY-MM-DD')
                          }
                          onChange={this.setComparisonStartDate}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          style={{ marginRight: 25 }}
                        />
                      )}
                      {/* </Col>
                    <Col> */}
                      {this.state.report !== 'persons' && (
                        <TextField
                          id='comparisonend'
                          label='Loppupäivä'
                          type='date'
                          variant='standard'
                          value={
                            this.state.comparisonenddate
                              ? moment
                                  .utc(this.state.comparisonenddate)
                                  .format('YYYY-MM-DD')
                              : moment.utc().format('YYYY-MM-DD')
                          }
                          onChange={this.setComparisonEndDate}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          style={{ marginRight: 25 }}
                        />
                      )}
                      {this.state.report === 'busy' ||
                      this.state.report === 'busyraw' ||
                      this.state.report === 'busyvisual' ? (
                        // <Row>
                        //   <Col>
                        <>
                          <FormControl>
                            <InputLabel id='comparison-starttime-select-label'>
                              Alkuaika
                            </InputLabel>
                            <Select
                              labelId='comparison-starttime-select-label'
                              id='comparison-starttime-select-label'
                              value={this.state.comparisonstarttime || '06:00'}
                              onChange={this.setComparisonStarttime}
                            >
                              {getTimeSteps(15).map((v, i) => {
                                return (
                                  <MenuItem key={v} value={v}>
                                    {v}
                                  </MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>{' '}
                          <FormControl>
                            <InputLabel id='comparison-endttime-select-label'>
                              Loppuaika
                            </InputLabel>
                            <Select
                              labelId='comparison-endttime-select-label'
                              id='comparison-endttime-select-label'
                              value={this.state.comparisonendtime || '23:00'}
                              onChange={this.setComparisonEndtime}
                            >
                              {getTimeSteps(15).map((v, i) => {
                                return (
                                  <MenuItem key={v} value={v}>
                                    {v}
                                  </MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </>
                      ) : //   </Col>
                      // </Row>
                      null}
                    </Col>
                  </Row>
                </>
              )}
              {this.state.comparison && <Divider style={{ marginTop: 20 }} />}
            </div>
          ) : null}
          <Row>
            <Col xs={2}>
              <Button
                disabled={
                  !(
                    this.state.startdate &&
                    this.state.enddate &&
                    this.state.report &&
                    this.state.allvalid
                  )
                }
                onClick={() => this.getReport()}
              >
                {this.state.loading ? <Spinner size={'sm'} /> : 'Hae raportti'}
              </Button>
            </Col>
            {this.state.report === 'payments' &&
              <Col>
                <Infobox index={0} />
              </Col>
            }
          </Row>
        </LocalizationProvider>
      </>
    )
  }
}

export default ReportsTimePicker
